export default __webpack_public_path__ + "static/conservarea-resurselor-8274c38b0a0b6f8051901d13b12b6507.jpg";